<!-- <div class="card">
    <div class="card-body">
        <h4 class="card-title">Interpretación de escalas</h4>

        <table class="table table-bordered table-hover " >
            <thead>
                <tr>
                    <th >Escala</th>
                    <th >Valor</th>
                    <th class="text-center">Borrar</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let interpretation of interpretations; index as i">
                    <td >{{interpretation.scale}}</td>
                    <td >{{interpretation.value}}</td>
                    <td class="footable-visible footable-last-column text-center">
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="handleDelete(i)" ><i class="fa fa-eraser" ></i></button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div> -->

<div class="card-body">
    <form>
        <div class="form-body">
            <h3 class="card-title">Crear o modificar interpretación</h3>
            <hr>
            <div class="row p-t-20">
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="control-label">Escala</label>
                        <select id="scaleSelector" (change)="changeType($event.target.value)" class="form-control custom-select">
                            <option value="validez">Validez</option>
                            <option value="clinicas">Clínicas</option>
                            <option value="lingoes">Harris-Lingoes</option>
                            <option value="contenido">Contenido</option>
                            <option value="suplementarias">Suplementarias</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="control-label">Subscala <span *ngIf="loadingScales"><img width="20" src="assets/images/loading.gif" alt=""> Cargando...</span></label>
                        <select *ngIf="scales.length>0" [(ngModel)]="scale.scale" (ngModelChange)="changeScale($event)" [ngModelOptions]="{standalone:true}" class="form-control custom-select">
                            <option disabled value=''>Seleccione escala...</option>
                            <option *ngFor="let s of scales | mfm" [value]="s.scale">A-{{s.scale}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div *ngIf="scale.scale" class="row p-t-20">
                <div class="col-md-4">
                    <div class="form-group">
                        <label class="control-label">Mínimo</label>
                        <input [(ngModel)]="rank.min" [ngModelOptions]="{standalone:true}" type="number"  class="form-control" placeholder="Mínimo">
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label class="control-label">Máximo</label>
                        <input [(ngModel)]="rank.max" [ngModelOptions]="{standalone:true}" type="number"  class="form-control" placeholder="Máximo">
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label class="control-label">Nombre del intervalo</label>
                        <input [(ngModel)]="rank.name" [ngModelOptions]="{standalone:true}" type="text"  class="form-control" placeholder="Nombre del intervalo">
                    </div>
                </div>
                <div class="col-md-12">
                    <h3 *ngIf="scale.scale=='Mf'">Interpretación varones</h3>
                    <div class="row justify-content-center">
                        <div class="NgxEditor__Wrapper p-20 m-b-40 col-12">
                            <ngx-editor-menu *ngIf="editor" [editor]="editor"> </ngx-editor-menu>
                            <ngx-editor
                              [editor]="editor"
                              [(ngModel)]="html"
                              [placeholder]="'Escriba su texto...'"
                              [ngModelOptions]="{standalone:true}"
                            ></ngx-editor>
                        </div>
                    </div>
                </div>
                <div *ngIf="scale.scale=='Mf'" class="col-md-12">
                    <h3>Interpretación mujeres</h3>
                    <div class="row justify-content-center">
                        <div class="NgxEditor__Wrapper p-20 m-b-40 col-12">
                            <ngx-editor-menu *ngIf="editor2" [editor]="editor2"> </ngx-editor-menu>
                            <ngx-editor
                              [editor]="editor2"
                              [(ngModel)]="html2"
                              [placeholder]="'Escriba su texto...'"
                              [ngModelOptions]="{standalone:true}"
                            ></ngx-editor>
                        </div>
                    </div>
                </div>
                <button (click)="addRank()" class="btn btn-rounded waves-effect btn-primary m-b-20">Agregar/reemplazar rango</button>
            </div>
        </div>
        <div *ngIf="scale.scale" class="card">
            <div class="card-body">
                <h4 class="card-title">A-{{scale.scale}}</h4>
        
                <table class="table table-bordered table-hover " >
                    <thead>
                        <tr>
                            <th >Mínimo</th>
                            <th >Máximo</th>
                            <th >Editar/Borrar</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let r of scale.ranks; index as i">
                            <td >{{r.min}}</td>
                            <td >{{r.max}}</td>
                            <td class="footable-visible footable-last-column text-center">
                                <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " data-toggle="modal" data-target="#myModal" (click)="editRank(r)" ><i class="fa fa-pencil" aria-hidden="true"></i></button>
                                <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="deleteRank(i)" ><i class="fa fa-eraser" ></i></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="form-actions m-t-20 m-b-20">
            <button type="button" (click)="update()" class="btn btn-rounded waves-effect btn-success">Actualizar escala seleccionada</button>
        </div>
    </form>
</div>